import React from 'react';
import Header from './header';
import Footer from './footer';

const PrivacyNotice = () => {
  return (
    
   <div className="bg-white text-gray-800">
  <div className="w-full">
    <Header/>
  </div>
   <div className="max-w-4xl mx-auto p-8  bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-100">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Privacy Notice</h1>
        <p className="text-lg text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
      </div>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Protecting Your Privacy</h2>
        <p className="text-gray-700 leading-7 mb-4">
          This Privacy Notice explains how Anvitech including its affiliates, inter-related companies, 
          and wholly owned subsidiaries ("Anvitech" or "We") collect, use, share, and protect information 
          regarding Anvitech marketing activities that refer to this Privacy Notice. This information on 
          personal data collection and processing ("Privacy Notice") explains how we protect visitors' 
          information gathered via this Website.
        </p>
        <p className="text-gray-700 leading-7">
          Anvitech reserves the right to change this Privacy Notice at any time.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Information We Collect and How We Collect It</h2>
        <p className="text-gray-700 leading-7 mb-4">
          This Website is designed to be accessible without the submission of any personal data. However, 
          if you choose to voluntarily provide personal information through specific features or 
          functionalities (e.g., contact forms, subscription), your data will be collected and processed 
          in accordance with applicable data protection laws. Anvitech will act as the data controller 
          and will obtain your explicit consent before processing any personal data, you may have the 
          option to decline providing that information.
        </p>
        <p className="text-gray-700 leading-7 mb-4">
          Please note that this Website does not collect or process any special categories of personal 
          data (sensitive personal information).
        </p>
        
        <div className="bg-gray-50 p-6 rounded-lg mb-4">
          <h3 className="text-lg font-semibold text-gray-900 mb-3">
            The personal information we collect may include:
          </h3>
          <ul className="space-y-2">
            <li className="text-gray-700 flex items-start">
              <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
              Name
            </li>
            <li className="text-gray-700 flex items-start">
              <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
              Company Name
            </li>
            <li className="text-gray-700 flex items-start">
              <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
              Email addresses
            </li>
            <li className="text-gray-700 flex items-start">
              <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
              IP address
            </li>
            <li className="text-gray-700 flex items-start">
              <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
              Phone
            </li>
            <li className="text-gray-700 flex items-start">
              <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
              Location
            </li>
          </ul>
        </div>

        <p className="text-gray-700 leading-7 mb-4">
          This Website automatically collects certain technical information about your device and your 
          interactions with our site. Specifically, we use cookies, web beacons, and similar technologies 
          to track your activity and preferences. A "cookie" is a small piece of data that a website can 
          send to your browser, which may then be stored on your device. Data that we collect automatically 
          includes your internet protocol ("IP") address, location, your device's identification information, 
          and the actions taken on our site (e.g., links that you click). For more details on our cookie 
          usage and purposes, please refer to our Cookie policy.
        </p>
        <p className="text-gray-700 leading-7">
          We may also collect anonymous data about website visitors to analyze trends and improve your 
          user experience. This data does not personally identify you.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Social Media</h2>
        <p className="text-gray-700 leading-7">
          This Website may incorporate social media features that allow you to share content with other 
          users (collectively referred to as "Social Media Applications"). Any Personal Information or 
          other information that you contribute to any Social Media Application can be read, collected 
          and used by other users of that Social Media Application over whom we have little or no control. 
          Therefore, we are not responsible for any other user's use, misuse or misappropriation of any 
          Personal Information or other information that you contribute to any Social Media Application.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">How Your Information Will Be Used</h2>
        <p className="text-gray-700 leading-7 mb-4">
          Anvitech processes personal information for legitimate business and marketing purposes, including:
        </p>
        
        <div className="space-y-4 mb-4">
          <div className="border-l-4 border-blue-500 pl-4">
            <h3 className="font-semibold text-gray-900 mb-2">Business Communications</h3>
            <p className="text-gray-700 leading-6">
              To provide information about our services, respond to inquiries, fulfil requests, and 
              communicate for customer service or business-related matters.
            </p>
          </div>
          <div className="border-l-4 border-blue-500 pl-4">
            <h3 className="font-semibold text-gray-900 mb-2">Marketing and Analytics</h3>
            <p className="text-gray-700 leading-6">
              To send newsletters, articles, promotional materials, and other marketing communications, 
              subject to your consent where required by law. We also analyse data to improve our marketing 
              strategies and enhance user engagement.
            </p>
          </div>
        </div>

        <p className="text-gray-700 leading-7 mb-4">
          You may opt out of receiving marketing communications at any time by following the unsubscribe 
          instructions provided in our communications or by contacting us directly.
        </p>
        <p className="text-gray-700 leading-7">
          Anvitech retains personal information only for as long as necessary to fulfill the purposes 
          outlined in this Privacy Notice, unless a longer retention period is required or permitted by 
          applicable law. We maintain strict data review and retention policies to ensure compliance with 
          legal and regulatory obligations.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Information Security</h2>
        <p className="text-gray-700 leading-7 mb-4">
          Anvitech uses reasonable technical, administrative, and physical measures to protect your 
          personal information. When your personal information is shared, Anvitech will take a reasonable 
          approach to prevent the unauthorized use of personal information.
        </p>
        <p className="text-gray-700 leading-7 mb-4">
          We have implemented industry-standard security practices and maintain high security standards 
          to ensure that our policies and procedures are aligned with best practices.
        </p>
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
          <p className="text-gray-700 leading-7 text-sm">
            Please note, however, that while Anvitech attempts to safeguard your personal information, 
            no method of transmitting or storing electronic information is ever completely secure, and 
            thus we make no warranty, express, implied, or otherwise, that your information will never 
            be accessed, used or released in a manner that is inconsistent with this Privacy Notice.
          </p>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">With Whom Your Information Will Be Shared</h2>
        <p className="text-gray-700 leading-7 mb-4">
          Anvitech does not share personal information with third parties except as stated in this 
          Privacy Notice. We may disclose information to companies affiliated with Anvitech and/or 
          unaffiliated third parties:
        </p>
        <div className="bg-gray-50 p-4 rounded-lg mb-4">
          <p className="text-gray-700 leading-6 mb-2">• to provide the products and services you have requested; and</p>
          <p className="text-gray-700 leading-6">
            • for administrative, analytical, and marketing purposes. For example, we may provide 
            information we collect about you to third parties to distribute promotions, marketing 
            surveys, interviews and other opportunities offered by Anvitech.
          </p>
        </div>
        <p className="text-gray-700 leading-7">
          Where we are required by applicable law, we will seek your consent prior to sharing your 
          personal information with such third parties for marketing purposes. Also, you can opt out 
          of having your information shared with third parties for those parties' direct marketing 
          purposes by emailing us at <span className="text-blue-600">privacy@anvitechsolutions.com</span>.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Cross Border Data Transfer</h2>
        <p className="text-gray-700 leading-7 mb-4">
          Anvitech operates on a global scale, which may require the transfer, storage, and processing 
          of personal data in jurisdictions outside of your country of residence. These jurisdictions 
          may have data protection laws that differ from those in your country.
        </p>
        <p className="text-gray-700 leading-7 mb-4">
          To ensure adequate protection, Anvitech relies on the European Commission's Standard 
          Contractual Clauses (SCCs) for transfers subject to the EU General Data Protection Regulation 
          (GDPR) and, where applicable, adheres to the requirements of applicable data protection laws.
        </p>
        <p className="text-gray-700 leading-7">
          By providing your personal information, you acknowledge and consent to its transfer, storage, 
          and processing in countries where Anvitech and its affiliates operate.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Use of Pretrained Chatbots and Data Privacy</h2>
        <p className="text-gray-700 leading-7 mb-4">
          Anvitech uses pretrained chatbots to facilitate business communications and respond to 
          inquiries. While the chatbot may collect limited personal information, such as name, email, 
          and conversation details, this information is used solely for business purposes, including 
          responding to customer queries, providing requested information, and facilitating potential 
          business engagements.
        </p>
        <p className="text-gray-700 leading-7">
          The chatbot does not engage in profiling, automated decision-making, or behavioral tracking. 
          All collected information is handled securely and retained only as necessary for business 
          needs or to meet legal requirements.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Your Rights</h2>
        <p className="text-gray-700 leading-7 mb-4">
          You may have various rights under your local law in relation to the personal information we 
          hold about you. In particular, you may have a legal right to:
        </p>
        <div className="space-y-3 mb-4">
          <div className="flex items-start">
            <span className="w-2 h-2 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
            <p className="text-gray-700 leading-6">
              obtain confirmation that we are processing your personal information and request a copy 
              of the personal information we hold about you.
            </p>
          </div>
          <div className="flex items-start">
            <span className="w-2 h-2 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
            <p className="text-gray-700 leading-6">
              ask that we update the personal information we hold about you or ask that we correct 
              such personal information that you think is incorrect or incomplete.
            </p>
          </div>
          <div className="flex items-start">
            <span className="w-2 h-2 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
            <p className="text-gray-700 leading-6">
              ask that we delete personal information that we hold about you, or restrict the way in 
              which we use such personal information.
            </p>
          </div>
          <div className="flex items-start">
            <span className="w-2 h-2 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
            <p className="text-gray-700 leading-6">
              withdraw consent to our processing of your personal information.
            </p>
          </div>
          <div className="flex items-start">
            <span className="w-2 h-2 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
            <p className="text-gray-700 leading-6">
              receive a copy of the personal information concerning you in a structured, commonly used 
              and machine-readable format.
            </p>
          </div>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Opt Out of Marketing Communications</h2>
        <p className="text-gray-700 leading-7 mb-4">
          If you want to opt out of receiving forms of communication from Anvitech other than marketing 
          email, or if you want Anvitech to stop sharing your personal information with third parties 
          for those parties' direct marketing purposes, please email{' '}
          <span className="text-blue-600 font-medium">privacy@anvitechsolutions.com</span> with your request.
        </p>
        <p className="text-gray-700 leading-7">
          Regardless of your opt-out preferences, we reserve the right to send you certain communications 
          and share your information with third parties for administrative and analytical purposes.
        </p>
      </section>

      <section className="mb-8 bg-blue-50 p-6 rounded-lg">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact Information</h2>
        <p className="text-gray-700 leading-7 mb-2">
          If you have any questions about this Privacy Notice or our privacy practices, please contact us at:
        </p>
        <div className="text-gray-700">
          <p className="mb-1"><strong>Email:</strong> renu@anvitechsolutions.com</p>
          <p className="mb-1"><strong>Address:</strong> Hetal Arch premises, C-403, S.V. Rd, opp. Natraj Market, Malad West, Mumbai, Maharashtra 400064</p>
          {/* <p>Your Company Address Here</p> */}
        </div>
      </section>
</div>
<div className="max-full">
<Footer/>
</div>
    </div>
  );
};

export default PrivacyNotice;